<template>
  <div>
    <v-layout wrap>
      <template v-for="(item, i) in checkingData">
        <v-flex xs12 sm12 md6 lg6 pa-2 v-if="item.checkingNum" :key="i">
          <DataChecking :checkingMessage="item.checkingMessage" :checkingNum="item.checkingNum" :routerLink="item.routerLink" v-model="checkingModel" :checkingArr="item.checkingArr" />
        </v-flex>
      </template>
    </v-layout>
    <GuidelineCoFactor :CoFactorAnalyteMismatchedUnitGroups="CoFactorAnalyteMismatchedUnitGroups" />
  </div>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import {
    splitArray,
  } from '@/helpers/arrays'
  import {
    pluralize,
  } from '@/helpers/strings'
  import GuidelineCoFactor from './CoFactor/GuidelineCoFactor'
  import DataChecking from '@/components/DataChecking'
  const stations = createNamespacedHelpers('stations')
  const guidelines = createNamespacedHelpers('guidelines')
  const admin = createNamespacedHelpers('admin')
  const authenticate = createNamespacedHelpers('authenticate')
  const cofactor = createNamespacedHelpers('cofactor')

  export default {
    components: {
      GuidelineCoFactor,
      DataChecking,
    },
    data() {
      return {
        tab: 'tab-1',
        search: '',
        headers: [{
          text: 'Name',
          value: 'GuidelineLongName',
          align: 'left',
        },
        {
          text: 'Category',
          value: 'Category',
          align: 'left',
        },
        {
          text: 'Feasible Media Types',
          value: 'Medias',
          align: 'left',
        },
        {
          value: null,
        },
        ],
        pagination: {
          sortBy: 'longName',
          rowsPerPage: 10,
        },
        checkingData: [],
        checkingModel: '',
        CoFactorAnalyteMismatchedUnitGroups: [],
      }
    },
    mounted() {
      if (!this.roleList || !this.roleList.length) {
        this.getRoleList()
      }
      this.fetchData()
    },
    computed: {
      ...stations.mapGetters(['mediaTypeList']),
      ...guidelines.mapGetters(['Guidelines']),
      ...admin.mapGetters(['roleList']),
      ...authenticate.mapGetters(['currentUserGroup']),
      ...cofactor.mapGetters(['cofactorList', 'dataCheckKey']),
      tenantList() {
        return JSON.parse(JSON.stringify(this.roleList))
      },
      GuidelineList() {
        var data = JSON.parse(JSON.stringify(this.Guidelines))
        data.forEach(element => {
          element.Medias = element.Medias.map(x => x.Name).join()
        })
        return data
      },
    },
    watch: {
      currentUserGroup() {
        this.fetchData()
      },
      dataCheckKey() {
        this.checkingData = []
        this.dataChecking()
      },

    },
    methods: {
      pluralize,
      ...admin.mapActions(['getRoleList']),
      ...cofactor.mapActions(['getCofactorData', 'coFactorChecking']),
      async fetchData() {
        if (this.currentUserGroup.id) {
          await this.dataChecking()
          this.getCofactorData(this.currentUserGroup.id)
        }
      },
      async dataChecking() {
        let options = {
          data: this.currentUserGroup.id,
          successCb: (res) => {
            this.checkingDataSettle(res)
          },
          failedCb: () => {},
        }
        this.coFactorChecking(options)
      },
      checkingDataSettle(data) {
        if (data.CoFactorWithoutLink && data.CoFactorWithoutLink.length) {
          let arr = this.setNameArr(data.CoFactorWithoutLink)
          this.checkingData.push({
            checkingMessage: data.CoFactorWithoutLink.length == 1 ? this.$t('CofactorManage.cofactorWithoutLinkMsg') : this.$t('CofactorManage.cofactorsWithoutLinkMsg'),
            checkingArr: arr,
            checkingNum: data.CoFactorWithoutLink.length.toString(),
            linkMessage: this.$t('CofactorManage.cofactorWithoutLinkLinkMsg'),
          })
        }

        if (data.CoFactorWithoutDefaultValue && data.CoFactorWithoutDefaultValue.length) {
          let arr = this.setNameArr(data.CoFactorWithoutDefaultValue)
          this.checkingData.push({
            checkingMessage: data.CoFactorWithoutDefaultValue.length == 1 ? this.$t('CofactorManage.cofactorWithoutDefaultValueMsg') : this.$t('CofactorManage.cofactorsWithoutDefaultValueMsg'),
            checkingArr: arr,
            checkingNum: data.CoFactorWithoutDefaultValue.length.toString(),
            linkMessage: this.$t('CofactorManage.cofactorWithoutDefaultValueLinkMsg'),
          })
        }

        if (data.CoFactorWithDifferentDefaultValues && data.CoFactorWithDifferentDefaultValues.length) {
          let arr = this.constructDifferentDefaultValueAlert(data.CoFactorWithDifferentDefaultValues)
          this.checkingData.push({
            checkingMessage: data.CoFactorWithDifferentDefaultValues.length == 1 ? this.$t('CofactorManage.cofactorWithDifferentDefaultValuesMsg') : this.$t('CofactorManage.cofactorsWithDifferentDefaultValuesMsg'),
            checkingArr: arr,
            checkingNum: data.CoFactorWithDifferentDefaultValues.length.toString(),
            linkMessage: this.$t('CofactorManage.cofactorWithDifferentDefaultValuesLinkMsg'),
          })
        }

        if (data.CoFactorAnalyteWithMismatchedUnitGroups && data.CoFactorAnalyteWithMismatchedUnitGroups.length) {
          let arr = this.setNameArr(data.CoFactorAnalyteWithMismatchedUnitGroups)
          this.checkingData.push({
            checkingMessage: this.$t('CofactorManage.coFactorAnalyteWithMismatchedUnitGroupMsg', 
              {
                link: pluralize('link', data.CoFactorAnalyteWithMismatchedUnitGroups.length), 
                group: pluralize('group', data.CoFactorAnalyteWithMismatchedUnitGroups.length),
              }),
            checkingArr: arr,
            checkingNum: data.CoFactorAnalyteWithMismatchedUnitGroups.length.toString(),
            linkMessage: '',
          })
          this.CoFactorAnalyteMismatchedUnitGroups = data.CoFactorAnalyteWithMismatchedUnitGroups
        }
      },
      setNameArr(data) {
        let colNum = 2
        let nameArr = data.map(x => x.Name)
        let nameGroupingArr = splitArray(nameArr, colNum)
        return nameGroupingArr
      },
      constructDifferentDefaultValueAlert(data) {
        var message = data.map(x => 'For Analyte ' + x.AnalyteName + ': ' + x.Cofactors.map(d => d.Name))
        let nameGroupingArr = splitArray(message, 2)
        return nameGroupingArr        
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }
</style>